var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 4.5957V3.17188C24 1.54091 22.8248 0.21875 21.375 0.21875H2.625C1.17525 0.21875 0 1.54091 0 3.17188V4.5957C0 4.7413 0.104953 4.85938 0.234375 4.85938H23.7656C23.895 4.85938 24 4.7413 24 4.5957Z","fill":"#D1DADA","key":0}),React.createElement("path",{"d":"M0 6.81055V15.8281C0 17.4591 1.17525 18.7812 2.625 18.7812H21.375C22.8248 18.7812 24 17.4591 24 15.8281V6.81055C24 6.66495 23.895 6.54688 23.7656 6.54688H0.234375C0.104953 6.54688 0 6.66495 0 6.81055ZM6 13.7188C6 14.1847 5.66419 14.5625 5.25 14.5625H4.5C4.08581 14.5625 3.75 14.1847 3.75 13.7188V12.875C3.75 12.409 4.08581 12.0312 4.5 12.0312H5.25C5.66419 12.0312 6 12.409 6 12.875V13.7188Z","fill":"#D1DADA","key":1})]);
}

CreditCard.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
